import forDevice from '../../../common/hoc/for-device';
import MyPostsFrameDesktop from './my-posts-frame-desktop';
import MyPostsFrameMobile from './my-posts-frame-mobile';

export default forDevice(MyPostsFrameMobile, MyPostsFrameDesktop);
